import { LikertRecord } from "@/domain/entities/Likert";
import { reactive, toRefs } from "vue";
import { db } from '@/infraestructure/datasource'
import { DoctorNote } from "@/domain/entities/EntityFields";

interface _State {
    likertRecords: LikertRecord[]
    doctorNotes: DoctorNote[]
    measurements: MeasurementRecord[]
}

const state = reactive<_State>({
    likertRecords: [],
    doctorNotes: [],
    measurements: []
})


let listeningDoctorNotes : any | undefined;
function listenDoctorNotes(patientId: string) {
    if (listeningDoctorNotes) {
        listeningDoctorNotes()
    }
    listeningDoctorNotes = db.collection(`patients/${patientId}/doctor_notes`).orderBy('createdAt').onSnapshot((snapshot) => {
        state.doctorNotes = snapshot.docs.map(d => ({ ...d.data() } as DoctorNote))
    })
}

let listeningMeasurements : any | undefined;
function listenMeasurements(patientId: string) {
    if (listeningMeasurements) {
        listeningMeasurements()
    }
    listeningMeasurements = db.collection(`patients/${patientId}/measurements`).orderBy('dateTime', 'desc').onSnapshot((snapshot) => {
        console.log(`docs found ${snapshot.docs.length}`);
        
        state.measurements = snapshot.docs.map(d => ({ ...d.data() } as MeasurementRecord))
    })
}

export default function usePatientHelper() {
    function fetchLikertRecords(patientId: string) {
        db.collection(`patients/${patientId}/likert_records`).orderBy('date').get().then((likertRecordDocs) => {
            state.likertRecords = likertRecordDocs.docs.map(d => ({ ...d.data() } as LikertRecord))
        })
    }

    function fetchDoctorNotes(patientId: string) {
        db.collection(`patients/${patientId}/doctor_notes`).orderBy('createdAt').get().then((doctorNoteDocs) => {
            state.doctorNotes = doctorNoteDocs.docs.map(d => ({ ...d.data() } as DoctorNote))
        })
    }
    async function insertDoctorNote(doctorNote: DoctorNote, patientId: string) {
        await db.collection(`patients/${patientId}/doctor_notes`).add(doctorNote)
    }

    return {
        ...toRefs(state), fetchLikertRecords, fetchDoctorNotes, insertDoctorNote, listenDoctorNotes, listenMeasurements
    }
}
